export enum DistributionMode {
  Live = "Live",
  Linear = "Linear",
}
